import React from "react";
import moment from "moment";
import { Tag } from "primereact/tag";

const MeaEvenTypeBadge = ({ event, isBox }) => {
  const badgeInfos = getToneForEvent(event);
  return (
    <Tag value={event.title} style={{ width: "100%", backgroundColor: badgeInfos.backgroundColor, color: badgeInfos.color }} />
  );
};

export const getToneForEvent = (event) => {
  const eventType = event?.event_type;
  switch (eventType) {
    case "MEETING":
      return { backgroundColor: "#D32F2F", color: "white" };
    case "VACATION":
      return { backgroundColor: "#1F4E79", color: "white" };
    case "BANK_HOLIDAY":
      return { backgroundColor: "#FF9800", color: "white" };
    case "COURSE_SESSION":
      const currentDate = moment().startOf("day");
      const endDate = moment(event?.endDate).startOf("day");
      if (endDate.isAfter(currentDate)) {
        return { backgroundColor: "#00AEEF", color: "white" };
      } else if (endDate.isBefore(currentDate)) {
        return { backgroundColor: "#B0B0B0", color: "#8c6161" };
      } else {
        return { backgroundColor: "#28A745", color: "white" };
      }
    default:
      return { backgroundColor: "#9C27B0", color: "white" };
  }
};

export default MeaEvenTypeBadge;
